var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "order-risk-trace-container" },
    [
      _c("transition", { attrs: { name: "fade-slide" } }, [
        _vm.riskData
          ? _c("div", { staticClass: "risk-dashboard" }, [
              _c(
                "div",
                {
                  staticClass: "risk-main-card",
                  class: _vm.getRiskLevelClass(_vm.riskData.riskLevel),
                },
                [
                  _c("div", { staticClass: "risk-glow" }),
                  _c("div", { staticClass: "risk-pulse" }, [
                    _c("span", { staticClass: "risk-level-in-circle" }, [
                      _vm._v(_vm._s(_vm.riskData.riskLevel || "未知")),
                    ]),
                  ]),
                  _c("div", { staticClass: "risk-icon-wrapper" }, [
                    _c("i", {
                      staticClass: "el-icon-warning-outline risk-icon",
                    }),
                    _c("span", { staticClass: "risk-label-inline" }, [
                      _vm._v("RISK LEVEL"),
                    ]),
                  ]),
                  _c("div", { staticClass: "risk-content" }, [
                    _c("div", { staticClass: "risk-score-bar" }, [
                      _c("div", { staticClass: "score-label" }, [
                        _vm._v("风险分值"),
                      ]),
                      _c("div", { staticClass: "score-value" }, [
                        _vm._v(_vm._s(_vm.riskData.totalScore || 0)),
                      ]),
                      _c("div", { staticClass: "score-bar-bg" }, [
                        _c("div", {
                          staticClass: "score-bar-fill",
                          style: {
                            width:
                              (_vm.riskData.totalScore || 0) > 0
                                ? Math.min(_vm.riskData.totalScore || 0, 100) +
                                  "%"
                                : "5%",
                          },
                        }),
                      ]),
                    ]),
                  ]),
                ]
              ),
              _c("div", { staticClass: "info-card" }, [
                _c("div", { staticClass: "info-card-header" }, [
                  _c("div", { staticClass: "info-icon order-icon" }, [
                    _c("i", { staticClass: "el-icon-document" }),
                  ]),
                  _c("div", { staticClass: "info-title" }, [
                    _vm._v("订单信息"),
                  ]),
                ]),
                _c("div", { staticClass: "info-body" }, [
                  _c("div", { staticClass: "info-row" }, [
                    _c("span", { staticClass: "info-label" }, [
                      _vm._v("订单号"),
                    ]),
                    _c("span", { staticClass: "info-value" }, [
                      _vm._v(_vm._s(_vm.riskData.orderNo)),
                    ]),
                  ]),
                  _c("div", { staticClass: "info-row" }, [
                    _c("span", { staticClass: "info-label" }, [
                      _vm._v("订单金额"),
                    ]),
                    _c("span", { staticClass: "info-value amount" }, [
                      _vm._v(
                        _vm._s(_vm.riskData.symbol) +
                          _vm._s(_vm.riskData.orderAmount)
                      ),
                    ]),
                  ]),
                ]),
              ]),
              _c("div", { staticClass: "info-card" }, [
                _c("div", { staticClass: "info-card-header" }, [
                  _c("div", { staticClass: "info-icon time-icon" }, [
                    _c("i", { staticClass: "el-icon-time" }),
                  ]),
                  _c("div", { staticClass: "info-title" }, [
                    _vm._v("检测时间"),
                  ]),
                ]),
                _c("div", { staticClass: "info-body" }, [
                  _c("div", { staticClass: "info-row single" }, [
                    _c("span", { staticClass: "info-value time" }, [
                      _vm._v(_vm._s(_vm.riskData.checkTime)),
                    ]),
                  ]),
                ]),
              ]),
            ])
          : _vm._e(),
      ]),
      _vm.riskData
        ? _c(
            "transition-group",
            {
              staticClass: "detail-sections",
              attrs: { name: "stagger", tag: "div" },
            },
            [
              _c(
                "div",
                { key: "rules", staticClass: "detail-card rules-card" },
                [
                  _c("div", { staticClass: "card-decoration-line" }),
                  _c("div", { staticClass: "detail-header" }, [
                    _c("div", { staticClass: "header-icon warning-icon" }, [
                      _c("i", { staticClass: "el-icon-warning" }),
                    ]),
                    _c("div", { staticClass: "header-text" }, [
                      _c("h3", [_vm._v("命中规则")]),
                      _c("p", [
                        _vm._v(
                          "Hit Rules - " +
                            _vm._s(_vm.hitRules.length) +
                            " 条规则命中"
                        ),
                      ]),
                    ]),
                  ]),
                  _c(
                    "div",
                    { staticClass: "table-wrapper" },
                    [
                      _c(
                        "el-table",
                        {
                          staticClass: "risk-table",
                          attrs: { data: _vm.hitRules, stripe: "" },
                        },
                        [
                          _c("el-table-column", {
                            attrs: {
                              prop: "ruleName",
                              label: "规则名称",
                              width: "200",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _c(
                                        "div",
                                        { staticClass: "rule-name-cell" },
                                        [
                                          _c("span", {
                                            staticClass: "rule-dot",
                                          }),
                                          _vm._v(
                                            " " +
                                              _vm._s(scope.row.ruleName) +
                                              " "
                                          ),
                                        ]
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              1152207894
                            ),
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "reason",
                              label: "规则描述",
                              "min-width": "200",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "score",
                              label: "风险分值",
                              width: "140",
                              align: "center",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "score-cell",
                                          class: _vm.getScoreCellClass(
                                            scope.row.score
                                          ),
                                        },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "score-number" },
                                            [_vm._v(_vm._s(scope.row.score))]
                                          ),
                                          _c(
                                            "span",
                                            { staticClass: "score-unit" },
                                            [_vm._v("分")]
                                          ),
                                        ]
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              1656410748
                            ),
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]
              ),
              _c(
                "div",
                { key: "device", staticClass: "detail-card device-card" },
                [
                  _c("div", { staticClass: "card-decoration-line" }),
                  _c("div", { staticClass: "detail-header" }, [
                    _c("div", { staticClass: "header-icon location-icon" }, [
                      _c("i", { staticClass: "el-icon-location-information" }),
                    ]),
                    _c("div", { staticClass: "header-text" }, [
                      _c("h3", [_vm._v("设备与位置")]),
                      _c("p", [_vm._v("Device & Location Information")]),
                    ]),
                  ]),
                  _c("div", { staticClass: "info-grid" }, [
                    _c("div", { staticClass: "info-item-card" }, [
                      _c("div", { staticClass: "item-label" }, [
                        _vm._v("设备 ID"),
                      ]),
                      _c("div", { staticClass: "item-value" }, [
                        _vm._v(_vm._s(_vm.riskData.deviceId || "-")),
                      ]),
                    ]),
                    _c("div", { staticClass: "info-item-card" }, [
                      _c("div", { staticClass: "item-label" }, [
                        _vm._v("IP 地址"),
                      ]),
                      _c("div", { staticClass: "item-value ip" }, [
                        _vm._v(_vm._s(_vm.riskData.ipAddress || "-")),
                      ]),
                    ]),
                    _c("div", { staticClass: "info-item-card full-width" }, [
                      _c("div", { staticClass: "item-label" }, [
                        _vm._v("地理位置"),
                      ]),
                      _c("div", { staticClass: "item-value" }, [
                        _vm._v(_vm._s(_vm.riskData.location || "-")),
                      ]),
                    ]),
                  ]),
                ]
              ),
              _c("div", { key: "user", staticClass: "detail-card user-card" }, [
                _c("div", { staticClass: "card-decoration-line" }),
                _c("div", { staticClass: "detail-header" }, [
                  _c("div", { staticClass: "header-icon user-icon" }, [
                    _c("i", { staticClass: "el-icon-user" }),
                  ]),
                  _c("div", { staticClass: "header-text" }, [
                    _c("h3", [_vm._v("用户信息")]),
                    _c("p", [_vm._v("User Information")]),
                  ]),
                ]),
                _c("div", { staticClass: "info-grid" }, [
                  _c("div", { staticClass: "info-item-card" }, [
                    _c("div", { staticClass: "item-label" }, [
                      _vm._v("用户 ID"),
                    ]),
                    _c("div", { staticClass: "item-value" }, [
                      _vm._v(_vm._s(_vm.riskData.userId)),
                    ]),
                  ]),
                  _c("div", { staticClass: "info-item-card" }, [
                    _c("div", { staticClass: "item-label" }, [
                      _vm._v("用户姓名"),
                    ]),
                    _c("div", { staticClass: "item-value" }, [
                      _vm._v(_vm._s(_vm.riskData.userName || "-")),
                    ]),
                  ]),
                  _c("div", { staticClass: "info-item-card" }, [
                    _c("div", { staticClass: "item-label" }, [
                      _vm._v("手机号"),
                    ]),
                    _c("div", { staticClass: "item-value phone" }, [
                      _vm._v(_vm._s(_vm.riskData.userPhone || "-")),
                    ]),
                  ]),
                ]),
              ]),
              _vm.flightInfo
                ? _c(
                    "div",
                    { key: "flight", staticClass: "detail-card flight-card" },
                    [
                      _c("div", { staticClass: "card-decoration-line" }),
                      _c("div", { staticClass: "detail-header" }, [
                        _c("div", { staticClass: "header-icon flight-icon" }, [
                          _c("i", { staticClass: "el-icon-s-promotion" }),
                        ]),
                        _c("div", { staticClass: "header-text" }, [
                          _c("h3", [_vm._v("航班信息")]),
                          _c("p", [_vm._v("Flight Information")]),
                        ]),
                      ]),
                      !_vm.hasFlightInfo
                        ? _c("div", { staticClass: "flight-empty" }, [
                            _c("div", { staticClass: "empty-icon" }, [
                              _vm._v("✈️"),
                            ]),
                            _c("p", [_vm._v("暂无航班信息")]),
                          ])
                        : _c("div", { staticClass: "flight-info-wrapper" }, [
                            _vm.flightInfo.fromSegment &&
                            _vm.flightInfo.fromSegment.length
                              ? _c("div", { staticClass: "flight-section" }, [
                                  _c(
                                    "div",
                                    { staticClass: "flight-section-header" },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "flight-icon-bg departure",
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "el-icon-right",
                                          }),
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "flight-header-text" },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "flight-title" },
                                            [_vm._v("去程航班")]
                                          ),
                                          _c(
                                            "div",
                                            { staticClass: "flight-subtitle" },
                                            [
                                              _vm._v(
                                                "共 " +
                                                  _vm._s(
                                                    _vm.flightInfo.fromSegment
                                                      .length
                                                  ) +
                                                  " 段行程"
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "div",
                                    { staticClass: "flight-segments" },
                                    _vm._l(
                                      _vm.flightInfo.fromSegment,
                                      function (segment, index) {
                                        return _c(
                                          "div",
                                          {
                                            key: "from-" + index,
                                            staticClass: "flight-segment",
                                          },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "segment-number" },
                                              [
                                                _vm._v(
                                                  "第 " +
                                                    _vm._s(index + 1) +
                                                    " 段"
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "el-tag",
                                              {
                                                staticClass:
                                                  "flight-number-tag",
                                                attrs: {
                                                  size: "small",
                                                  type: "primary",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(segment.flightNumber)
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "div",
                                              { staticClass: "segment-route" },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "airport-dep",
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      { staticClass: "code" },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            segment.depAirportCode
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "div",
                                                      { staticClass: "time" },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.formatFlightTime(
                                                              segment.depTime
                                                            )
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "route-arrow",
                                                  },
                                                  [
                                                    _c("div", {
                                                      staticClass: "arrow-line",
                                                    }),
                                                    _c("i", {
                                                      staticClass:
                                                        "el-icon-d-arrow-right",
                                                    }),
                                                  ]
                                                ),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "airport-arr",
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      { staticClass: "code" },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            segment.arrAirportCode
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "div",
                                                      { staticClass: "time" },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.formatFlightTime(
                                                              segment.arrTime
                                                            )
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        )
                                      }
                                    ),
                                    0
                                  ),
                                ])
                              : _vm._e(),
                            _vm.flightInfo.retSegment &&
                            _vm.flightInfo.retSegment.length
                              ? _c(
                                  "div",
                                  { staticClass: "flight-section return" },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "flight-section-header" },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "flight-icon-bg return",
                                          },
                                          [
                                            _c("i", {
                                              staticClass: "el-icon-back",
                                            }),
                                          ]
                                        ),
                                        _c(
                                          "div",
                                          { staticClass: "flight-header-text" },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "flight-title" },
                                              [_vm._v("返程航班")]
                                            ),
                                            _c(
                                              "div",
                                              {
                                                staticClass: "flight-subtitle",
                                              },
                                              [
                                                _vm._v(
                                                  "共 " +
                                                    _vm._s(
                                                      _vm.flightInfo.retSegment
                                                        .length
                                                    ) +
                                                    " 段行程"
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "flight-segments" },
                                      _vm._l(
                                        _vm.flightInfo.retSegment,
                                        function (segment, index) {
                                          return _c(
                                            "div",
                                            {
                                              key: "ret-" + index,
                                              staticClass: "flight-segment",
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "segment-number",
                                                },
                                                [
                                                  _vm._v(
                                                    "第 " +
                                                      _vm._s(index + 1) +
                                                      " 段"
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "el-tag",
                                                {
                                                  staticClass:
                                                    "flight-number-tag",
                                                  attrs: {
                                                    size: "small",
                                                    type: "success",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(segment.flightNumber)
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "segment-route",
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "airport-dep",
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        { staticClass: "code" },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              segment.depAirportCode
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                      _c(
                                                        "div",
                                                        { staticClass: "time" },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.formatFlightTime(
                                                                segment.depTime
                                                              )
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "route-arrow",
                                                    },
                                                    [
                                                      _c("div", {
                                                        staticClass:
                                                          "arrow-line",
                                                      }),
                                                      _c("i", {
                                                        staticClass:
                                                          "el-icon-d-arrow-right",
                                                      }),
                                                    ]
                                                  ),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "airport-arr",
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        { staticClass: "code" },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              segment.arrAirportCode
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                      _c(
                                                        "div",
                                                        { staticClass: "time" },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.formatFlightTime(
                                                                segment.arrTime
                                                              )
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          )
                                        }
                                      ),
                                      0
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ]),
                    ]
                  )
                : _vm._e(),
              _c(
                "div",
                { key: "allrules", staticClass: "detail-card allrules-card" },
                [
                  _c("div", { staticClass: "card-decoration-line" }),
                  _c("div", { staticClass: "detail-header" }, [
                    _c("div", { staticClass: "header-icon grid-icon" }, [
                      _c("i", { staticClass: "el-icon-s-grid" }),
                    ]),
                    _c("div", { staticClass: "header-text" }, [
                      _c("h3", [_vm._v("全部规则检测结果")]),
                      _c("p", [
                        _vm._v(
                          "All Rules Detection Results - " +
                            _vm._s(_vm.allRulesResult.length) +
                            " 条规则"
                        ),
                      ]),
                    ]),
                  ]),
                  _c(
                    "div",
                    { staticClass: "table-wrapper" },
                    [
                      _c(
                        "el-table",
                        {
                          staticClass: "risk-table",
                          attrs: { data: _vm.allRulesResult, stripe: "" },
                        },
                        [
                          _c("el-table-column", {
                            attrs: {
                              prop: "ruleName",
                              label: "规则名称",
                              width: "200",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _c(
                                        "div",
                                        { staticClass: "rule-name-cell" },
                                        [
                                          _c("span", {
                                            staticClass: "rule-dot",
                                            class: { hit: scope.row.hit },
                                          }),
                                          _vm._v(
                                            " " +
                                              _vm._s(scope.row.ruleName) +
                                              " "
                                          ),
                                        ]
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              2920116306
                            ),
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "result",
                              label: "检测结果",
                              width: "120",
                              align: "center",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "result-badge",
                                          class: scope.row.hit ? "hit" : "safe",
                                        },
                                        [
                                          _c("i", {
                                            class: scope.row.hit
                                              ? "el-icon-warning"
                                              : "el-icon-success",
                                          }),
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                scope.row.hit
                                                  ? "命中"
                                                  : "未命中"
                                              )
                                            ),
                                          ]),
                                        ]
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              2215531844
                            ),
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "score",
                              label: "分值",
                              width: "100",
                              align: "center",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _c(
                                        "span",
                                        { staticClass: "score-value" },
                                        [_vm._v(_vm._s(scope.row.score))]
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              2595656070
                            ),
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "detail",
                              label: "详情",
                              "min-width": "200",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]
              ),
            ]
          )
        : _vm._e(),
      _c("transition", { attrs: { name: "fade" } }, [
        !_vm.riskData && !_vm.loading
          ? _c("div", { staticClass: "empty-state" }, [
              _c("div", { staticClass: "empty-illustration" }, [
                _c("div", { staticClass: "pulse-ring" }),
                _c("div", { staticClass: "pulse-ring delay-1" }),
                _c("div", { staticClass: "pulse-ring delay-2" }),
                _c("i", { staticClass: "el-icon-warning-outline" }),
              ]),
              _c("h2", [_vm._v("暂无数据")]),
              _c("p", [_vm._v("未能获取到风控信息")]),
            ])
          : _vm._e(),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }